import { useEffect, useState } from "react";
import { getEventTemplates } from "@/services/api/templates";
import type { EventTemplateDefinition } from "@/lib/event-templates";

/**
 * The designs `GET /templates` lists: the built-in designs and every active
 * installed template package (JUB-161). `null` until the API answers, and it
 * stays `null` when the request fails, so a caller falls back to the built-in
 * designs (`offeredTemplatesOf`, `resolveTemplateDefinition`). Shared by the
 * editor's Landing tab and the onboarding wizard (JUB-213).
 */
export function useTemplateCatalog(): EventTemplateDefinition[] | null {
  const [catalog, setCatalog] = useState<EventTemplateDefinition[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    getEventTemplates()
      .then((templates) => {
        if (!cancelled && Array.isArray(templates)) setCatalog(templates);
      })
      .catch((error: unknown) => {
        console.warn("[templates] Failed to load the template catalog", error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return catalog;
}
